import { templateParse } from "../../logic/templateParse.js";
import type { BootstrapOffcanvas } from "../../types/bootstrap.js";
import type { FileArchiveDefRow } from "@bonusmap/api-types";
import { DataBaseComponent } from "./data-base-component.js";
import { BonusFileComponent } from "../bonus-file/bonus-file.js";
import { toastError, toastSuccess } from "../../toasts.js";
import { isNumber } from "@bonusmap/shared_ui/library";
export class DataFilesComponent extends DataBaseComponent {
    static webComponentName: string = "data-files";
    protected _templateId: string = "data-files-component";

    constructor() {
        super();
        this.setupGlobalListeners();
    }
    public get rowId(): number {
        const dataCollector = this.querySelector("data-base-collector");
        if (dataCollector && 'rowId' in dataCollector) {
            return (dataCollector as any).rowId;
        }
        return 0;
    }
    protected onConnected(): void {
        super.onConnected();
    }
    protected get components(): BonusFileComponent[] {
        return Array.from(this.querySelectorAll(`${BonusFileComponent.webComponentName}[file-id]`)) as BonusFileComponent[];
    }
    protected setupSyncEventListeners(): void {
        // No sync events needed
    }
    protected setupGlobalListeners(): void {
        this.on("cancel-requested", BonusFileComponent.webComponentName, () => {
            console.log("DataFilesComponent detected cancel-requested event");
        });
        this.on("changed", BonusFileComponent.webComponentName, () => {
            this.value = this.getValueFromComponents();
            this.render(); // Rerender to update the list of files   
        });
        this.on("file-removed", BonusFileComponent.webComponentName, async (ev: Event) => {
            const rowId = this.rowId;
            if (rowId === 0) {
                console.log("DataFilesComponent detected file-removed but no valid rowId, ignoring.");
                return; // No valid rowId
            }
            const value = this.getValueFromComponents();
            console.log("DataFilesComponent detected file-removed, updating value to:", value);
            const apiResponse = await window.api.manager.bonus.updatePartial(rowId, { files: value });
            if (apiResponse.success) {
                this.value = value;
                this.render(); // Rerender to update the list of files   
                this.dispatch("changed", {});
                console.log("Files updated successfully after removal.");

            } else {
                toastError("Errore nel rimuovere i file");
            }
        })
    }
    protected getValueFromComponents(): number[] {
        const result: number[] = [];
        this.components.forEach(cmp => {
            if (cmp.fileId) {
                const id = parseInt(cmp.fileId.toString());
                if (isNumber(id)) {
                    result.push(id);
                }
            }
        });
        return result;
    }
    protected async render(): Promise<void> {
        this.currentDataForTemplate = await this.addDataForTemplate();
        const mainHtml = templateParse(this.templateId, this.currentDataForTemplate);
        if (mainHtml) {
            this.innerHTML = mainHtml;
        }
        this.afterRender();
    }
    private currentDataForTemplate: Record<string, any> | null = null;

    async addDataForTemplate(): Promise<Record<string, any>> {
        return {
            field: this.field,
            value: this.value,
            readonly: this.readOnly,
        }
    }
}